import r2wc from '@r2wc/react-to-web-component';
import LatestNews from "../components/LatestNews";


const EmLatestNews = r2wc(LatestNews, {
  props: {
    data: 'json'
  },
});

customElements.define("em-latest-news", EmLatestNews);
